import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import CreateUserDialog from "@/components/admin/CreateUserDialog";
import UserCard from "@/components/admin/UserCard";
import PendingTransfers from "@/components/admin/PendingTransfers";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-page">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-sm font-semibold text-[var(--red)] uppercase tracking-[0.2em]">Administration</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[var(--navy)] mt-2">Manage users & accounts</h1>
        </div>
        <CreateUserDialog onCreated={load} />
      </div>
      <Tabs defaultValue="users">
        <TabsList className="mb-6 bg-white border h-11">
          <TabsTrigger value="users" data-testid="admin-tab-users">Users ({users.length})</TabsTrigger>
          <TabsTrigger value="pending" data-testid="admin-tab-pending">Pending transfers</TabsTrigger>
        </TabsList>
        <TabsContent value="users" className="grid gap-6">
          {users.map((u) => <UserCard key={u.id} user={u} onChange={load} />)}
        </TabsContent>
        <TabsContent value="pending"><PendingTransfers onChange={load} /></TabsContent>
      </Tabs>
    </div>
  );
}
